import React from 'react';
import Dashboard from './components/Dashboard';

function Home() {
  return <Dashboard />;
}

export default Home; 